
export const session = {
    clear: clear,
    getItem: getItem,
    setItem: setItem
}
 function clear() {
 session.clear();
}

 function setItem(key: any, value: any) {
    return sessionStorage.setItem(key, value);
}

function getItem(key: any) {
    return sessionStorage.getItem(key);
} 